interface ToolbarItemProps {
  children?: React.ReactNode;
}

export const ToolbarItem = ({ children }: ToolbarItemProps) => {
  const placeholder = <div className="h-6 w-6" />;
  return <div className="flex p-2.5">{children || placeholder}</div>;
};
